/** TanStack Query keys of the work orders. */

import type { ListParams } from '../types/workOrderTypes';

export const workOrderKeys = {
  all: ['work-orders'] as const,
  lists: () => [...workOrderKeys.all, 'list'] as const,
  list: (params: ListParams) => [...workOrderKeys.lists(), params] as const,
  counts: () => [...workOrderKeys.all, 'counts'] as const,
  card: (id: string) => [...workOrderKeys.all, 'card', id] as const,
  feed: (id: string) => [...workOrderKeys.all, 'feed', id] as const,
  statusOptions: (id: string) => [...workOrderKeys.all, 'status-options', id] as const,
  views: () => [...workOrderKeys.all, 'views'] as const,
  lookup: (kind: string, q: string) => [...workOrderKeys.all, 'lookup', kind, q] as const,
  time: (id: string) => [...workOrderKeys.all, 'time', id] as const,
  running: () => [...workOrderKeys.all, 'time', 'running'] as const,
  bySource: (kind: string, id: string) => [...workOrderKeys.all, 'by-source', kind, id] as const,
  openStay: (vehicleId: string) => [...workOrderKeys.all, 'open-stay', vehicleId] as const,
  payerOptions: (kind: string, id: string) => [...workOrderKeys.all, 'payer-options', kind, id] as const,
  vehicleHistory: (vehicleId: string) => [...workOrderKeys.all, 'vehicle-history', vehicleId] as const,
  documents: (id: string) => [...workOrderKeys.all, 'documents', id] as const,
  documentOptions: (id: string) => [...workOrderKeys.all, 'document-options', id] as const,
  clientLinks: (id: string) => [...workOrderKeys.all, 'client-links', id] as const,
  inviteOptions: (id: string) => [...workOrderKeys.all, 'invite-options', id] as const,
  media: (id: string) => [...workOrderKeys.all, 'media', id] as const,
  estimate: (id: string) => [...workOrderKeys.all, 'estimate', id] as const,
  myWorks: () => [...workOrderKeys.all, 'my-works'] as const,
  myMonth: () => [...workOrderKeys.all, 'my-month'] as const,
};
